<template>
    <router-link to="/login" class="home-button" tag="div">
        <v-btn class="px-4 text-capitalize">
            Войти
        </v-btn>
    </router-link>
</template>

<script lang='ts'>
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'

    export default Vue.extend({
        props: {
            classes: String
        },
        components: {

        },
        data() {
            return {
                
            }
        },
        computed: {

        },
        methods: {

        },
    })

    </script>

<style lang="scss" scoped>
</style>

<style lang="scss">
    .home-button{
        .v-btn{
            background-color: #16F68B !important;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
            border-radius: 8px !important;
            font-family: Roboto !important;
            font-style: normal !important;
            font-weight: normal !important;
            font-size: 24px !important;
            line-height: 31px !important;
            text-align: center !important;
            color: #000 !important;
            height: 65px !important;
            letter-spacing: 0.5px !important;
            text-decoration: none !important;
        }
    }

</style>